export const Prev = () => (
	<svg
		width="35"
		height="35"
		viewBox="0 0 35 35"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="rotate-180"
	>
		<g clip-path="url(#clip0_2067_1362)">
			<rect
				width="35"
				height="35"
				rx="2.97872"
				fill="white"
				fill-opacity="0.8"
			/>
			<path
				d="M14.5833 8.75L12.5271 10.8062L19.2063 17.5L12.5271 24.1938L14.5833 26.25L23.3333 17.5L14.5833 8.75Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2067_1362">
				<rect width="35" height="35" rx="2.97872" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const Next = () => (
	<svg
		width="35"
		height="35"
		viewBox="0 0 35 35"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2067_1362)">
			<rect
				width="35"
				height="35"
				rx="2.97872"
				fill="white"
				fill-opacity="0.8"
			/>
			<path
				d="M14.5833 8.75L12.5271 10.8062L19.2063 17.5L12.5271 24.1938L14.5833 26.25L23.3333 17.5L14.5833 8.75Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2067_1362">
				<rect width="35" height="35" rx="2.97872" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
